import { useAppSelector } from '@config/reduxStore';
import { GetPedido } from '@services/api/api.pedidos';
import { Skeleton } from 'antd';
import { Fragment } from 'react';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import OrdemStatusTag from '../../Ordens/Shared/OrdemStatusTag';
import '../../../../../assets/scss/PedidoView.scss';
import { doubleMask } from '@utils/masks';

function PedidoViewBody() {
  const { id } = useParams();
  const { data: pedido, isLoading } = GetPedido(id);
  const { user } = useAppSelector((state) => state.user);
  if (isLoading) return <Skeleton active />;
  return (
    <div className="pedidoView">
      <table className="pedidoView-header">
        <colgroup>
          <col className="pedidoView-logo" />
          <col className="pedidoView-title" />
          <col className="pedidoView-label" />
          <col className="pedidoView-info" />
        </colgroup>
        <thead>
          <tr>
            <th rowSpan={6}>
              <img src={user?.configuracao?.logo} alt="logo" height={60} />
            </th>
            <th rowSpan={6} className="title">
              PEDIDO
            </th>
            <th>Pedido Nº</th>
            <th>{pedido?.cod}</th>
          </tr>
          <tr>
            <th>Situação</th>
            <th>{<OrdemStatusTag status={pedido?.situacao} />}</th>
          </tr>
          <tr>
            <th>Data</th>
            <th>{moment(pedido?.dataCriacao).format('DD/MM/YYYY')}</th>
          </tr>
          <tr>
            <th>Orçamento</th>
            <th>{pedido?.orcamento}</th>
          </tr>
          <tr>
            <th>Prazo</th>
            <th>{moment(pedido?.prazoEntrega).format('DD/MM/YYYY')}</th>
          </tr>
          <tr>
            <th>Descrição</th>
            <th>{pedido?.descricao}</th>
          </tr>
        </thead>
      </table>
      <table className="pedidoView-body pedidoView-items">
        <colgroup>
          <col className="pedidoView-index" />
          <col className="pedidoView-category" />
          <col className="pedidoView-group" />
          <col className="pedidoView-item" />
          <col className="pedidoView-unit" />
          <col className="pedidoView-description" />
          <col className="pedidoView-quantity" />
        </colgroup>
        <tbody>
          <tr>
            <th colSpan={7}>ITENS</th>
          </tr>
          <tr>
            <th>Item</th>
            <th>Categoria</th>
            <th>Grupo</th>
            <th>Item</th>
            <th>Unidade</th>
            <th>Especificação</th>
            <th>Quantidade</th>
          </tr>
          {pedido?.itensPedido?.map((item, index) => (
            <tr key={index}>
              <td className="center">{index + 1}</td>
              <td>{item.categoria}</td>
              <td>{item.grupo}</td>
              <td>{item.item}</td>
              <td className="center">{item.unidade}</td>
              <td>{item.descricao}</td>
              <td className="value">{doubleMask.format(item.quantidade)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <table className="pedidoView-body pedidoView-processing">
        <colgroup>
          <col className="pedidoView-processing-item" />
          <col className="pedidoView-processing-unit" />
          <col className="pedidoView-processing-processed" />
          <col className="pedidoView-processing-order" />
          <col className="pedidoView-processing-status" />
        </colgroup>
        <tbody>
          <tr>
            <th colSpan={5}>Processamento dos Itens</th>
          </tr>
          <tr>
            <th>Item</th>
            <th>Unidade</th>
            <th>Processado</th>
            <th colSpan={2}>Ordens</th>
          </tr>
          {pedido?.ordens?.map((c) => {
            const ordens = c.ordens ?? [];
            const rowSpan = Math.max(ordens.length, 1);
            return (
              <Fragment key={c.id}>
                <tr>
                  <td className="center" rowSpan={rowSpan}>
                    {c.item}
                  </td>
                  <td className="center" rowSpan={rowSpan}>
                    {c.unidade}
                  </td>
                  <td className="center" rowSpan={rowSpan}>
                    {doubleMask.format(c.processado)}
                  </td>
                  {ordens.length > 0 ? (
                    <>
                      <td>{ordens[0].cod}</td>
                      <td>
                        <OrdemStatusTag status={ordens[0].situacao} />
                      </td>
                    </>
                  ) : (
                    <td colSpan={2} className="center muted">
                      Nenhuma ordem associada
                    </td>
                  )}
                </tr>
                {ordens
                  .filter((_, index) => index > 0)
                  .map((o) => (
                    <tr key={`${c.id}-${o.id}`}>
                      <td>{o.cod}</td>
                      <td>
                        <OrdemStatusTag status={o.situacao} />
                      </td>
                    </tr>
                  ))}
              </Fragment>
            );
          })}
          {pedido?.ordens?.length === 0 && (
            <tr>
              <td colSpan={5} className="center muted">
                Nenhum item processado
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default PedidoViewBody;
